import React from 'react';

import { Box, Button, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';

import { Delete, Edit } from '@mui/icons-material';
import { MaterialReactTable } from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

import CadastroCertificadoDialog from './dialogs/CadastroCertificadoDialog';

import { podeEditarItem, podeCancelarItem, podeImprimirItem } from '../../../../hooks/usePermisionMRT';
import { parseISO, format, isValid } from 'date-fns';

export default function TabCertificado({ module, cadastroModule, mrt }) {
    const { state, actions } = module;

    const columns = [
        {
            accessorKey: 'ambiente',
            header: 'Ambiente',
            muiTableBodyCellProps: ({ row, cell }) => ({
                onClick: () => {
                    console.info(row.original);
                },
            }),
        },
        {
            accessorKey: 'finalidade',
            header: 'Finalidade',
        },
        {
            accessorKey: 'cnpjCertificado',
            header: 'CNPJ',
        },
        {
            accessorKey: 'titular',
            header: 'Titular',
        },
        {
            accessorFn: (row) => new Date(row),
            accessorKey: 'validoAte',
            header: 'Validade',
            filterVariant: 'date',
            sortingFn: 'date',
            columnFilterModeOptions: [
                'fuzzy',
                'equals',
                'between',
                'betweenInclusive',
                'greaterThanOrEqualTo',
                'lessThanOrEqualTo',
            ],
            muiTableHeadCellFilterTextFieldProps: {
                type: 'date',
                InputLabelProps: {
                    shrink: true,
                },
                sx: {
                    minWidth: '200px',
                },
            },
            muiTableBodyCellProps: {
                align: 'center',
            },
            Cell: ({ row }) => {
                return (
                    <span>
                        {row.original?.validoAte
                            ? isValid(parseISO(row.original?.validoAte))
                                ? format(parseISO(row.original?.validoAte), 'dd/MM/yyyy HH:mm:ss')
                                : null
                            : null}
                    </span>
                );
            },
        },
        {
            accessorKey: 'ultimoTesteStatus',
            header: 'Status',
        },
        {
            accessorFn: (row) => new Date(row),
            accessorKey: 'ultimoTesteEm',
            header: 'Validade',
            filterVariant: 'date',
            sortingFn: 'date',
            columnFilterModeOptions: [
                'fuzzy',
                'equals',
                'between',
                'betweenInclusive',
                'greaterThanOrEqualTo',
                'lessThanOrEqualTo',
            ],
            muiTableHeadCellFilterTextFieldProps: {
                type: 'date',
                InputLabelProps: {
                    shrink: true,
                },
                sx: {
                    minWidth: '200px',
                },
            },
            muiTableBodyCellProps: {
                align: 'center',
            },
            Cell: ({ row }) => {
                return (
                    <span>
                        {row.original?.ultimoTesteEm
                            ? isValid(parseISO(row.original?.ultimoTesteEm))
                                ? format(parseISO(row.original?.ultimoTesteEm), 'dd/MM/yyyy HH:mm:ss')
                                : null
                            : null}
                    </span>
                );
            },
        },
        {
            accessorKey: 'ultimoTesteMensagem',
            header: 'Mensagem',
        },
        {
            accessorKey: 'ativo',
            header: 'Ativo',
            type: 'boolean',
            columnFilterModeOptions: ['equals'],
            filterSelectOptions: [
                { label: 'Todos', value: '' },
                { label: 'Sim', value: '1' },
                { label: 'Não', value: '0' },
            ],
            filterVariant: 'select',
            Cell: ({ row }) => {
                const value = row.original.ativo;
                return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
            },
        },
    ];
    const handleCertificado = async (obj) => {
        const { funcao, row, index } = obj;

        switch (funcao.toLowerCase()) {
            case 'cadastrar':
                actions.abrirCadastro();
                break;

            case 'editar':
                actions.abrirEdicao({ ...row, funcao: 'Editar' });
                break;

            case 'deletar':
                actions.abrirExclusao({ ...row, funcao: 'Deletar' });
                break;

            case 'testar':
                actions.testar(row);
                break;

            default:
                console.warn(`Função não implementada: ${funcao}`);
                break;
        }
    };
    return (
        <>
            <MaterialReactTable
                columns={columns}
                data={state.rows}
                enableColumnFilterModes
                enableGlobalFilterModes
                enableColumnOrdering
                enableEditing
                initialState={{
                    showColumnFilters: true,
                    density: 'compact',
                }}
                state={{
                    isLoading: state.loading,
                }}
                renderTopToolbarCustomActions={({ table }) => {
                    return (
                        <div
                            style={{
                                display: 'flex',
                                gap: '8px',
                            }}
                        >
                            <Tooltip arrow placement="top-end" title={`Novo Registro`}>
                                <div>
                                    <Button
                                        color="secondary"
                                        onClick={() => handleCertificado({ funcao: 'Cadastrar' })}
                                        variant="contained"
                                        disabled={!podeEditarItem()}
                                    >
                                        Cadastrar
                                    </Button>
                                </div>
                            </Tooltip>
                        </div>
                    );
                }}
                renderRowActions={({ row }) => (
                    <Box sx={{ display: 'flex', gap: '1rem' }}>
                        <Tooltip arrow placement="bottom" title="Editar">
                            <span>
                                <IconButton
                                    onClick={() => handleCertificado({ row: row.original, index: row.index, funcao: 'Editar' })}
                                    disabled={!podeEditarItem()}
                                >
                                    <Edit />
                                </IconButton>
                            </span>
                        </Tooltip>
                        <Tooltip arrow placement="top-start" title="Tornar o certificado inativo">
                            <span>
                                <IconButton
                                    color="error"
                                    onClick={() => handleCertificado({ row: row.original, index: row.index, funcao: 'Deletar' })}
                                    disabled={!podeCancelarItem()}
                                >
                                    <Delete />
                                </IconButton>
                            </span>
                        </Tooltip>
                        <Tooltip arrow placement="bottom" title="Testar certificado">
                            <span>
                                <IconButton
                                    color="primary"
                                    onClick={() =>
                                        handleCertificado({
                                            row: row.original,
                                            index: row.index,
                                            funcao: 'Testar',
                                        })
                                    }
                                    disabled={state.testingUuid === row.original.uuid || !row.original.ativo}
                                >
                                    <VerifiedUserIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </Box>
                )}
                localization={MRT_Localization_PT_BR}
            />
            <CadastroCertificadoDialog
                open={state.dialogOpen}
                onClose={actions.fecharDialog}
                selected={state.selected}
                loading={cadastroModule.state.loading}
                onConfirm={cadastroModule.actions.salvar}
            />
        </>
    );
}
